import Typography from '@material-ui/core/Typography';
import { alpha, makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

interface OnlinePillProps {
    // Optional override (e.g. CMS-configured copy); falls back to the i18n `Online` label.
    label?: string;
}

const useStyles = makeStyles((theme: any) => ({
    onlinePill: {
        flexShrink: 0,
        // Semi-transparent app primary color tint with normal text on top.
        backgroundColor: alpha(theme.palette.common.yellow, 0.2),
        color: theme.palette.common.darkGrey,
        borderRadius: theme.radius.default,
        padding: '0.125rem 0.5rem',
        fontSize: '0.75rem',
        fontWeight: 600,
        textTransform: 'none',
        whiteSpace: 'nowrap',
    },
}));

export const OnlinePill = ({ label }: OnlinePillProps) => {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <Typography component="span" className={classes.onlinePill}>
            {label || t('Online')}
        </Typography>
    );
};
